var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-widget',{attrs:{"plans":_vm.plans,"error":_vm.error,"addPlan":false,"loading":_vm.loading,"title":_vm.$t('New Orders')},on:{"refresh-widget":_vm.fetchPlans}})
}
var staticRenderFns = []

export { render, staticRenderFns }